import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { ReceiveApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  invoice_list_data: null,
  record_data: null,
  comment_log: null
};

const ReceiveSlice = createSlice({
  name: 'Receive',
  initialState,
  reducers: {
    setReceiveGrid(state, action) {
      state.list_data = action.payload;
    },
    setInvoiceGrid(state, action) {
      state.invoice_list_data = action.payload;
    },
    setReceiveRecord(state, action) {
      state.record_data = action.payload;
    }
    // setCommentLogs(state, action) {
    //   state.comment_log = action.payload;
    // }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Receive List
export const getReceiveList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: ReceiveApi?.receiveList,
      method: 'post',
      payload: data
    });
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setReceiveGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setReceiveGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Receive List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Receive List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// invoice List
export const getInvoiceList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: ReceiveApi?.invoiceList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setInvoiceGrid(res?.data?.data ? res?.data?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setInvoiceGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Receive List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Receive List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const DownloadReceivableRecords = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: ReceiveApi?.receiveDownloadRecord,
      method: 'post',
      payload: data
    });
    // 🔹 Handle success
    if (res?.success) {
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Receive List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Receive List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};
// Receive record
export const getReceiveRecordData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: ReceiveApi?.receiveRecord,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setReceiveRecord(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setReceiveRecord(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Receive record failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Receive record exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setReceiveGrid, setReceiveRecord, setCommentLogs, setInvoiceGrid } =
  ReceiveSlice.actions;
export default ReceiveSlice.reducer;
